import React, { Component } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import BaseVisualization from '@splunk/dashboard-visualizations/common/BaseVisualization';
import { parse, dataContract } from '@splunk/visualization-encoding-parsers/PunchcardParser';
import ReactPunchcard from '@splunk/react-visualizations/Punchcard';
import { enterprise } from '@splunk/visualization-themes/variables';
import Message from '@splunk/visualizations-shared/Message';
import { withVisualizationAndThemeHOCs } from '@splunk/dashboard-visualizations/utils/enhancer';
import IconPlaceholder from '@splunk/dashboard-visualizations/common/IconPlaceholder';
import { Punchcard as PunchcardIcon } from '@splunk/visualization-icons';
import optionsSchema from './optionsSchema';
import editorConfig from './editorConfig';

export class PunchcardComponent extends Component {
    static propTypes = BaseVisualization.propTypes;

    static defaultProps = {
        ...BaseVisualization.defaultProps,
        height: 250,
    };

    static dataContract = dataContract;

    static vizContract = {
        initialDimension: {
            width: 500,
            height: 500,
        },
    };

    static schema = optionsSchema;

    static editor = editorConfig;

    render() {
        const { dataSources, encoding, options, width, height } = this.props;
        let propsFromEncoding;

        try {
            propsFromEncoding = parse(dataSources, encoding);
        } catch (e) {
            return (
                <Message
                    data-test="punchcard-message"
                    width={width}
                    height={height}
                    level={e.level}
                    message={_(e.message)}
                />
            );
        }

        return <ReactPunchcard width={width} height={height} {...propsFromEncoding} {...options} />;
    }
}

export default withVisualizationAndThemeHOCs({
    defaultBackgroundColor: enterprise.defaultBackgroundColor,
    placeholder: <IconPlaceholder icon={<PunchcardIcon />} />,
})(PunchcardComponent);
